import { Component } from '@angular/core';

@Component({
  selector: 'app-ops-layout',
  templateUrl: './ops-layout.component.html',
  styleUrls: ['./ops-layout.component.scss'],
})
export class OpsLayoutComponent {}
